<template>
  <div class="overflow: auto">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">姓名/账号:</div>
        <Input v-model="keyword" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">选择状态:</div>
        <Select v-model="state" @on-change="changeInput" class="select">
          <Option v-for="item in types" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">按时间查询:</div>
        <DatePicker
          type="daterange"
          split-panels
          class="select"
          @on-change="queryTime"
        ></DatePicker>
      </div>
    </div>

    <Table
      style="font-size: 20px"
      :content="self"
      border
      stripe
      :columns="columns1"
      :data="data1"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: red; border-color: red"
          type="error"
          size="small"
          @click="
            jurisdiction = true;
            configJurisdiction(data1[index]);
            dataIndex = index;
          "
          >授权角色</Button
        >
        <br />
        <router-link style="width: 20%" :to="'/ProductOrder?id=' + row.id">
          <Button
            style="background: red; border-color: red"
            type="error"
            size="small"
            >查看进件</Button
          >
        </router-link>
      </template>
      <template slot-scope="{ row, index }" slot="statistics">
        总数量: {{ row.apTotal }}&nbsp;&nbsp;&nbsp; 已完成: {{ row.cpTotal }}
        <!-- <div v-for="data in row.groupCount">
          <div v-if="data.state!=2&&data.state!=3">{{data.state}}：{{data.count}}</div>
        </div>-->
      </template>
    </Table>
    <Modal
      width="800"
      v-model="jurisdiction"
      title="授权角色"
      @on-ok="SaveJurisdiction(data1[dataIndex])"
    >
      <Table
        style="font-size: 20px"
        :content="self"
        border
        stripe
        :columns="columns"
        :data="data"
      >
        <template slot-scope="{ row, index }" slot="confer">
          <Checkbox
            @on-change="Checkbox(row, index)"
            v-model="row.single"
          ></Checkbox>
        </template>
      </Table>
    </Modal>
    <Page
      style="margin-top: 10px"
      :total="total"
      @on-change="pagingSuery"
      show-elevator
    />
    <Modal width="40" v-model="AddUser" title="添加管理员" @on-ok="Add()">
      用户名：
      <Input v-model="username" style="width: auto; margin-right: 15px" />
      <br />
      <br />手机号：
      <Input v-model="phone" style="width: 370px; margin-right: 15px" />
      <br />
      <br />密码：
      <Input
        type="password"
        v-model="password"
        style="width: 370px; margin-right: 15px"
      />
    </Modal>
    <Button
      style="
        background: #2d8cf0;
        border-color: #2d8cf0;
        float: right;
        padding: 8px 30px;
        font-size: 20px;
      "
      type="error"
      size="small"
      @click="
        AddUser = true;
        username = '';
        phone = '';
        password = '';
      "
      >添加管理员</Button
    >
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Administrator",

  data() {
    return {
      columns: [
        {
          title: "角色名称",
          align: "center",
          key: "name",
        },
        {
          title: "描述",
          align: "center",
          key: "description",
        },
        {
          title: "授权",
          key: "address",
          align: "center",
          slot: "confer",
        },
      ],
      username: "",
      phone: "",
      password: "",
      data: [{}],
      pageNow: 0,
      jurisdiction: false,
      dataIndex: 0,
      AddUser: false,
      keyword: "",
      time: [],
      action: false,
      types: [
        {
          value: "0",
          label: "已冻结",
        },
        {
          value: "1",
          label: "正常",
        },
      ],
      state: "",
      self: this,
      total: 0,
      columns1: [
        {
          title: "用户名",
          align: "center",
          key: "username",
        },
        {
          title: "手机号",
          key: "phone",
          align: "center",
        },
        {
          title: "角色",
          align: "center",
          key: "role",
        },
        {
          title: "状态 ",
          align: "center",
          key: "state",
        },

        {
          title: "统计",
          key: "address",
          align: "center",
          slot: "statistics",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime",
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "action",
        },
      ],
      data1: [{}],
    };
  },
  mounted: function () {
    this.getData();
  },
  activated: function () {
    this.getData();
  },
  methods: {
    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.getData(this.keyword);
    },
    Checkbox(data, index) {
      this.data[index] = data;
    },
    SaveJurisdiction(data, res) {
      let roles = [];
      this.data.forEach((element) => {
        if (element.single == true) {
          roles.push(element.id);
        }
      });
      api
        .AdminAddRoles({
          id: data.id,
          roles: roles,
        })
        .then((res) => {
          this.getData();
        });
    },
    configJurisdiction(data) {
      api
        .RoleList({
          pageNow: "1",
          pageSize: "9999999",
          state: "1",
        })
        .then((res) => {
          this.data = res.body.data.list;
          this.data.forEach((element) => {
            element.single = false;
            data.roles.forEach((element1) => {
              if (element.id == element1.id) {
                element.single = true;
              }
            });
          });
        });
    },
    getData() {
      api
        .AdminList({
          pageNow: this.pageNow,
          pageSize: 10,
          keyword: this.keyword,
          state: this.state,
          startMillis: this.time[0],
          endMillis: this.time[1],
        })
        .then((res) => {
          this.total = res.body.data.total;
          this.data1 = res.body.data.list;
          this.data1.forEach((element) => {
            if (element.roles && element.roles.length != 0) {
              element.role = "";
              element.roles.forEach((role, index) => {
                element.role += role.name + ",";
              });
              element.role = element.role.substr(0, element.role.length - 1);
            }
            // if (element.groupCount && element.groupCount.length != 0) {
            //   let state = 0;
            //   let count = 0;
            //   let sum = 0;
            //   element.groupCount.forEach(element => {
            //     sum += element.count;
            //     if (element.state == 2) {
            //       state = element.state - 0 + state;
            //       count = element.count - 0 + count;
            //     }
            //     if (element.state == 3) {
            //       state = element.state - 0 + state;
            //       count = element.count - 0 + count;
            //     }
            //     if (element.state == 1) {
            //       element.state = "待确认";
            //     }
            //     if (element.state == 4) {
            //       element.state = "已作废";
            //     }
            //   });
            //   element.groupCount.push({
            //     state: "已完成",
            //     count
            //   });
            //   element.groupCount.push({
            //     state: "总数",
            //     count: sum
            //   });
            // }

            if (element.state == 0) {
              element.state = "已冻结";
            }
            if (element.state == 1) {
              element.state = "正常";
            }
            if (element.isMaster == 0) {
              element.isMaster = "否";
            }
            if (element.isMaster == 1) {
              element.isMaster = "是";
            }
          });
        });
    },
    Add() {
      api
        .AdminAdd({
          username: this.username,
          phone: this.phone,
          password: this.password,
        })
        .then((res) => {
          this.getData();
        });
    },
    changeInput() {
      this.pageNow = 0;
      this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    },
  },
};
</script>

<style scoped lang = 'less'>
</style>